@let viewConfig = this.pageViewConfig();
@let loading = this.specialsResource.isLoading();
@let currentLanguage = this.currentLanguage();

<app-header
  class="header"
  coreActivitySection="Header"
  [pageName]="pageName() | textTranslate: 'fallback'"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="onBack()"
>
  @if (viewConfig.header && viewConfig.header.title && viewConfig.header.title.text) {
    <app-header-text slot="center" [text]="viewConfig.header.title.text | textTranslate: currentLanguage"/>
  }

  @if (!viewConfig.header || !viewConfig.header.badge ||
  (viewConfig.header && viewConfig.header.badge && viewConfig.header.badge.type === 'table-name')) {
    <app-header-badge-table-name slot="right"/>
  } @else if (viewConfig.header && viewConfig.header.badge && viewConfig.header.badge.type === 'text') {
    <app-header-badge-text slot="right" [text]="viewConfig.header.badge.text | textTranslate: currentLanguage"/>
  }
</app-header>

@if (loading) {
  <app-loading/>
} @else {
  @let specials = this.specialsResource.value();

  @if (specials.length > 0 ||
  (viewConfig.welcomeSlide && viewConfig.welcomeSlide.image && viewConfig.emptyState.welcomeSlide &&
    viewConfig.emptyState.welcomeSlide.enabled)) {
    <swiper-container
      dir="ltr"
      class="swiper"
      [autoplay]="viewConfig.autoPlay
        ? {
          delay: viewConfig.autoPlayDelay ? (viewConfig.autoPlayDelay * 1000) : 5000,
          disableOnInteraction: viewConfig.autoPlayDisableOnInteraction
         }
        : false
      "
      [pagination]="true"
      [direction]="viewConfig.direction || 'vertical'"
      [loop]="!!viewConfig.loop"
    >
      @if (viewConfig.welcomeSlide && viewConfig.welcomeSlide.image) {
        <swiper-slide>
          @let image = viewConfig.welcomeSlide.image | imageTranslate: currentLanguage;

          <app-image
            class="slide"
            [image]="image"
            alt="Welcome Slide"
          />
        </swiper-slide>
      }

      @for (slide of specials; track slide.id; let i = $index) {
        @switch (slide.contentType) {
          @case ('video') {
            <swiper-slide>
              <video
                class="slide"
                [src]="slide.contentLocal"
                swiperControl
              ></video>
            </swiper-slide>
          }
          @case ('image') {
            <swiper-slide>
              <img
                class="slide"
                [src]="slide.contentLocal"
                [alt]="`Event ${i + 1}`"
              />
            </swiper-slide>
          }
        }
      }
    </swiper-container>
  } @else {
    <div class="empty">
      <app-text class="message">{{ viewConfig.emptyState.message | textTranslate: currentLanguage }}</app-text>
    </div>
  }
}
